<template>
    <div class="menu-wrapper">
        <nav>
            <ul>
                <li class="logo">
                    <img
                        src="../../../../img/icons/png/ugt_logo.png"
                        alt="UGT-SP"
                    />
                </li>
                <li>
                    <a href="/">Início</a>
                </li>
                <li>
                    <a>Notícias</a>
                    <div class="menu-dropdown">
                        <a href="/noticias/noticias-ugt">UGT-SP Notícias</a>
                        <a href="/noticias/palavra-do-presidente"
                            >Palavra do Presidente</a
                        >
                        <a href="/noticias/comentario-do-diretor"
                            >Comentário do Diretor</a
                        >
                    </div>
                </li>
                <li>
                    <a>Institucional</a>
                    <div class="menu-dropdown">
                        <a href="/institucional/carta-de-tupa">Carta de Tupã</a>
                        <a href="/institucional/diretoria">Diretoria</a>
                        <a href="/institucional/historia">História</a>
                        <a href="/institucional/valores">Missão, Visão e Valores</a>
                        <a href="/institucional/presidente">Presidente</a>
                    </div>
                </li>
                <li>
                    <a href="/publicacoes">Publicações</a>
                </li>
                <li>
                    <a href="/sistema">Emissão de Boletos</a>
                </li>
                <li>
                    <a href="/contato">Contato</a>
                </li>
                <li>
                    <button class="search" @click="showSearch = !showSearch">
                        <svg-icon icon="search"></svg-icon>
                    </button>
                </li>
                <div class="search-bar">
                    <transition name="fade"
                                enter-active-class="animate__animated animate__zoomIn"
                                leave-active-class="animate__animated animate__zoomOut">
                        <div v-show="showSearch" class="flex rounded-lg bg-white">
                            <input type="text" placeholder="Buscar..." v-model="busca">
                            <button class="px-2 rounded-r-lg focus:outline-none hover:bg-light-gray">
                                <router-link :to="'/busca/'+busca">
                                    <svg-icon icon="search" class="text-black"></svg-icon>
                                </router-link>
                            </button>
                        </div>

                    </transition>
                </div>
            </ul>
        </nav>
        <h1 v-if="title !== 'inicio'">{{ title }}</h1>

        <p v-if="title !== 'inicio'" :class="{'_page':breadcrumbs.subcategory === 'Missão, Visão e Valores'}">
            <span :class="!breadcrumbs.subcategory ? 'page' : ''">{{ breadcrumbs.category }}</span>
            {{breadcrumbs.subcategory ? '>' : ''}}
            <span class="page">{{ breadcrumbs.subcategory }}</span>
        </p>
    </div>
</template>

<script>
export default {
    name: 'navbar-main',
    props: ['title', 'breadcrumbs'],
    data() {
        return {
            active: false,
            showSearch: false,
            busca: ''
        }
    },
}
</script>

<style lang="scss" scoped>
.menu-wrapper {
    @apply pt-4 px-32 pb-12;
    @media (max-width: 1024px) {
        @apply py-0 px-8;
    }
    @media (max-width: 768px) {
        @apply py-2 px-4;
    }
    .logo {
        @apply w-24 mr-8;
    }
    ul {
        @media (max-width: 768px) {
            @apply hidden;
        }
        @apply flex justify-between items-center list-none m-0 p-0;
        li {
            @apply py-4 relative cursor-pointer;
            a {
                @apply text-white;
                transition: font .2s;
                &:hover {
                    @apply text-secondary;
                }
            }

            &:hover .menu-dropdown {
                @apply absolute flex flex-col bg-white text-dark-gray py-4 px-0;
                width: 200px;
                top: 20px;
                left: -40px;
                margin: 30px auto 0 auto;
                border-radius: 5px;
                & > a {
                    @apply py-0 px-4 mb-1 text-black;
                    &:hover {
                        @apply text-primary;
                    }
                    &:last-child {
                        @apply mb-0;
                    }
                }
            }

            .menu-dropdown {
                @apply hidden;
                &:after {
                    @apply w-0 h-0 absolute;
                    content: "";
                    border-left: 10px solid transparent;
                    border-right: 10px solid transparent;
                    border-bottom: 10px solid #fff;
                    top: -9px;
                    left: 30%;
                }
            }

            .search {
                @apply pr-2;
            }
            .search:active, .search:focus {
                outline: none;
            }
            .search svg {
                @apply text-secondary;
            }
        }
    }
    & > h1 {
        @apply font-bold py-8 px-0 text-5xl;
        @media (max-width: 768px) {
            @apply text-2xl py-4 px-0;
        }
    }

    & > p {
        @apply flex justify-between w-1/4 text-base py-8 px-0;
        @media (max-width: 768px) {
            @apply w-2/5;
        }
        @media (max-width: 500px) {
            @apply py-4 px-0;
            width: 90%;
        }
        span {
            @apply text-base text-white;
        }
        .page {
            @apply text-secondary;
        }
    }
    ._page {
        width: 30%;
        @media (max-width: 968px) {
            width: 50%;
        }
        @media (max-width: 500px) {
            width: 100%;
        }
    }
    .search-bar {
        @apply hidden;
        input {
            @apply w-full rounded-lg px-2 py-1 outline-none text-black;
            &:focus {
                @apply outline-none;
            }
        }
        @media (min-width: 769px) {
            @apply pr-8 inline absolute right-0;
            top: 160px;
            width: 300px;
        }
        @media (min-width: 1024px) {
            @apply pr-32 inline absolute right-0;
            top: 180px;
            width: 400px;
        }
    }
}

</style>
